module.exports = __webpack_public_path__ + "img/history-line.d6b8d944.svg";